import logo from "../assets/Logo Curebay 3.png";
import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";

export default function Header() {
  const navigate = useNavigate();
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const profileMenuRef = useRef(null);

  const handleLogout = () => {
    // Clear all authentication data from localStorage
    localStorage.removeItem('access_token');
    localStorage.removeItem('token_type');
    localStorage.removeItem('user_id');
    localStorage.removeItem('user_name');
    localStorage.removeItem('user_email');
    localStorage.removeItem('isAuthenticated');
    
    // Close menu
    setShowProfileMenu(false);
    
    // Navigate to login page
    navigate('/');
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileMenuRef.current && !profileMenuRef.current.contains(event.target)) {
        setShowProfileMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <header className="absolute top-0 left-0 w-full h-[60px] bg-white flex flex-col justify-center items-start px-[120px] py-[19px] gap-[10px] z-[99999]">
      {/* Header Content */}
      <div className="flex flex-row justify-between items-center p-0 w-full h-[40px] flex-none order-0 self-stretch">
        
        {/* Logo Container */}
        <Link to="/">
          <div className="flex flex-row items-center p-0 gap-[11.71px] w-[114px] h-[27.64px] flex-none order-0">
            <img
              src='https://intellimed.org/wp-content/uploads/2024/09/intelimed-logo.jpg'
              alt="Intelimed"
              className="w-[136px] h-[42px] flex-none order-0 object-contain"
            />
          </div>
        </Link>

        {/* Right Controls */}
        <div className="flex flex-row items-center p-0 gap-3 md:gap-[16px] h-[40px] flex-none order-1">
          <Link
            to="/sessions"
            className="hidden sm:inline-flex items-center text-sm font-semibold text-blue-600 hover:text-blue-700"
          >
            My Sessions
          </Link>
          {/* Profile Icon with Dropdown */}
          <div className="relative" ref={profileMenuRef}>
            <button
              onClick={() => setShowProfileMenu(!showProfileMenu)}
              className="relative w-[40px] h-[40px] rounded-[120px] flex-none order-0 cursor-pointer transition-all hover:shadow-lg"
              style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
              }}
            >
              {/* Profile Initial */}
              <span 
                className="absolute w-[16px] h-[29px] font-['Inter'] font-bold text-[24px] leading-[29px] flex items-center tracking-[0.003em] text-white"
                style={{
                  left: 'calc(50% - 16px/2)',
                  top: 'calc(50% - 29px/2 + 0.5px)'
                }}
              >
                {localStorage.getItem('user_name')?.charAt(0).toUpperCase() || 'A'}
              </span>
            </button>
            
            {/* Dropdown Menu */}
            {showProfileMenu && (
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
                {/* User Info */}
                <div className="px-4 py-2 border-b border-gray-200">
                  <p className="text-sm font-semibold text-gray-900">
                    {localStorage.getItem('user_name') || 'User'}
                  </p>
                  <p className="text-xs text-gray-500 truncate">
                    {localStorage.getItem('user_email') || ''}
                  </p>
                </div>
                
                {/* Logout Option */}
                <button
                  onClick={handleLogout}
                  className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}